// ============================================================================
// LE DÉROULÉ D'UN CONTRÔLE DE LA BARRE DU HAUT — le lanceur « Applications » et la cloche « À traiter » le partagent.
//
// ⚠️ UNE SEULE DÉFINITION pour les deux : deux déroulés voisins ne doivent pas différer, et chacun avait déjà son écart
//    (l'un à 36 px du haut du bouton, l'autre 6 px sous lui). La maquette les ouvre tous deux 8 px sous le bouton.
// ============================================================================
import type { CSSProperties } from 'react';

/** Écart entre le bas du bouton et le haut du panneau. */
const PANEL_GAP = 8;

export const TOPBAR_PANEL = {
  /** Géométrie d'ancrage : aligné à droite du bouton, `PANEL_GAP` sous lui. */
  geom: (width: number) => ({ width, align: 'end' as const, offsetY: PANEL_GAP }),
  style: {
    padding: 8, borderRadius: 'var(--r-md)', background: 'var(--panel)', border: '1px solid var(--line)',
    boxShadow: '0 18px 50px -18px rgba(0,0,0,.55)',
  } satisfies CSSProperties,
};
